var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"rollEl",staticClass:"BigDataRoll",on:{"scroll":_vm.countAntiShake}},[_c('div',{staticClass:"BigDataRoll-all",style:({ 'height': _vm.sumHeight })},[_c('div',{staticClass:"BigDataRoll-mian",style:({
        'transform': 'translateY(' + _vm.topHeight + ')',
      })},[_vm._t("default",null,{"list":_vm.data})],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }